import styled from "styled-components";
import { NarrowFilter, NavButton } from "../../components";

export const StyledWrapper = styled.div`
  margin-top: 0;
`;

export const StyledNavButton = styled(NavButton)`
  margin-bottom: ${({ theme }) => theme.space.sm};
`;

export const StyledFiltersWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.sm};
`;

export const StyledSearchBar = styled(NarrowFilter)`
  margin-top: 1.25rem;
  margin-bottom: ${({ theme }) => theme.space.xs};
  width: 20rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 40rem;
  }
`;

export const StyledListWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.gray800};
`;
